import { IonButton, IonIcon } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import KioskLayout, { LockMode } from '@components/KioskLayout';
import { useCountdown } from '@hooks/useCountdown';

import { SponsorImage } from './SponsorImage';

const Footer = styled.div`
  width: 100%;
  padding: 0 32px 32px;
  text-align: center;
`;

const Icon = styled(IonIcon)`
  width: 170px;
  height: 170px;
`;

interface Props {
  dismiss: () => void;
}

// We need to pass the router instance to the component because its not available to modals
export const Success = ({ dismiss }: Props) => {
  const countdown = useCountdown(dismiss);

  return (
    <KioskLayout
      lockMode={LockMode.None}
      disableBack
      footer={
        <>
          <Footer>
            <p
              style={{ marginTop: 0 }}
            >{t`You will be automatically redirected in ${countdown}...`}</p>
            <IonButton expand="block" onClick={dismiss}>
              {t`Done`}
            </IonButton>
          </Footer>
          <SponsorImage />
        </>
      }
    >
      <Icon icon={checkmarkCircleOutline} color="primary" size="large" />
      <h1>{t`Success!`}</h1>
      <p>{t`Badge printed`}</p>
    </KioskLayout>
  );
};
